import { connect } from 'react-redux';
import { pipe } from 'ramda';
import { resetStatuses, pageChange } from 'store/common';
import { bootstrapAppRequestAction, bootstrapInitRequestAction } from 'store/modules/bootstrap/actions';
import { isAppDeprecatedSelector } from 'store/modules/app/selectors';
import { visibilityChange } from 'store/modules/app/actions';

export const mapStateToProps = state => ({
  isAppVersionDeprecated: isAppDeprecatedSelector(state),
});

export const mapDispatchToProps = dispatch => ({
  resetStatuses: pipe(resetStatuses, dispatch),
  pageChange: pipe(pageChange, dispatch),
  bootstrapInitRequestAction: pipe(bootstrapInitRequestAction, dispatch),
  bootstrapAppRequestAction: pipe(bootstrapAppRequestAction, dispatch),
  visibilityChange: pipe(visibilityChange, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
